import { render } from "./CampaignsSummary.vue?vue&type=template&id=1cc9639d&scoped=true"
import script from "./CampaignsSummary.vue?vue&type=script&lang=js"
export * from "./CampaignsSummary.vue?vue&type=script&lang=js"

import "./CampaignsSummary.vue?vue&type=style&index=0&id=1cc9639d&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc9639d"]])

export default __exports__